import L from "leaflet";

var path1 = [  new L.LatLng(

    31.54595713,
    -97.11817068,
),
    new L.LatLng(

        31.54591785,
        -97.11821085,
    ),
    new L.LatLng(

        31.54601421,
        -97.11833134
    ),
    new L.LatLng(

        31.54630489,
        -97.11799953
    ),
    new L.LatLng(

        31.54653237,
        -97.11825719
    ),
    new L.LatLng(

        31.54650183,
        -97.11829662
    )
]
var path2=  [
      new L.LatLng(

          31.54640317,
          -97.11818437,
      ),
      new L.LatLng(

          31.54644864,
          -97.11812558,
      ),
      new L.LatLng(

          31.54656397,
          -97.11826275,
      ),
      new L.LatLng(

          31.54651425,
          -97.11831187
      )
    ];

var path3=  [
    new L.LatLng(

        31.54587857,
        -97.1183432,
    ),
    new L.LatLng(

        31.54586486,
        -97.11836337,
    ),
    new L.LatLng(

        31.54592547,
        -97.11842832,
    ),
    new L.LatLng(

        31.54632006,
        -97.11795859
    ),
    new L.LatLng(

        31.54625284,
        -97.1178751
    ),
    new L.LatLng(

        31.54627198,
        -97.11785146
    )
];



export default path3;
